import React from 'react';

const DataPrivacyPolicy = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Data Privacy Policy for XGO Life App</h1>
      <p className="mb-4">Last Updated: February 6, 2025</p>

      <h2 className="text-2xl font-semibold mt-6">Introduction</h2>
      <p className="mb-4">
        At Xgo Life, we are committed to protecting your privacy and ensuring that your personal information is handled responsibly. This Data Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our mobile applications, websites, and services (collectively, the “Services”).
      </p>

      <h2 className="text-2xl font-semibold">Information We Collect</h2>
      
      <h3 className="text-xl font-semibold mt-4">Personal Information</h3>
      <p className="mb-4">
        We may collect personal information that you provide directly to us, including but not limited to:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Payment information</li>
        <li>Address</li>
      </ul>

      <h3 className="text-xl font-semibold">Usage Data</h3>
      <p className="mb-4">
        We may automatically collect certain information about your interactions with our Services, such as:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>Device information (e.g., device type, operating system)</li>
        <li>IP address</li>
        <li>Browser type</li>
        <li>Pages visited</li>
        <li>Time and date of access</li>
      </ul>

      <h3 className="text-xl font-semibold">Cookies and Tracking Technologies</h3>
      <p className="mb-4">
        We use cookies and similar tracking technologies to enhance your experience. You can manage your cookie preferences through your browser settings.
      </p>

      <h2 className="text-2xl font-semibold">How We Use Your Information</h2>
      <p className="mb-4">
        We may use the information we collect for various purposes, including:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>To provide and maintain our Services</li>
        <li>To process transactions and manage payments</li>
        <li>To communicate with you, including sending updates and promotional materials</li>
        <li>To improve our Services and analyze usage patterns</li>
        <li>To ensure the security and integrity of our Services</li>
      </ul>

      <h2 className="text-2xl font-semibold">Disclosure of Your Information</h2>
      <p className="mb-4">
        We do not sell your personal information to third parties. However, we may share your information in the following circumstances:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Service Providers:</strong> We may employ third-party companies to facilitate our Services and process your information.</li>
        <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
      </ul>

      <h2 className="text-2xl font-semibold">Security of Your Information</h2>
      <p className="mb-4">
        We take reasonable measures to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure.
      </p>

      <h2 className="text-2xl font-semibold">Your Rights</h2>
      <p className="mb-4">
        Depending on your jurisdiction, you may have the following rights regarding your personal information:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>The right to access and receive a copy of your personal information</li>
        <li>The right to rectify inaccurate or incomplete information</li>
        <li>The right to request deletion of your personal information</li>
        <li>The right to object to or restrict the processing of your personal information</li>
      </ul>
      <p className="mb-4">To exercise any of these rights, please contact us at [contact email].</p>

      <h2 className="text-2xl font-semibold">Changes to This Policy</h2>
      <p className="mb-4">
        We may update this Data Privacy Policy from time to time. We will notify you of any changes by posting the new policy on our website and updating the “Last Updated” date.
      </p>

      <h2 className="text-2xl font-semibold">Contact Us</h2>
      <p className="mb-4">
        If you have any questions about this Data Privacy Policy, please contact us at:
      </p>
      <p className="mb-4">Xgo Life</p>
      <p className="mb-4">[Your Company Address]</p>
      <p className="mb-4">Email: [contact email]</p>
    </div>
  );
};

export default DataPrivacyPolicy;